module.exports = __webpack_public_path__ + "csfexpresswp0b20764af143a4ca6300cb5c6886634c.png";